// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-p_fC","galleryItem_borderTopRadius":"c-p_fE","galleryItem__image":"c-p_fF"};